module.exports = __webpack_public_path__ + "static/media/hyundai-vial.9af71c04.svg";